<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">

      <div class="mb-2 p-2 border-bottom border-light">
        <h5 class="font-weight-light">
          <span><i class="fa-light fa-trash fa-lg"></i></span>
          Excluir Usuário
        </h5>
      </div>
      <b-form>
        <b-form-row>
          <b-col cols="12" md="6" lg="4" class="mt-2 mt-lg-3 form-group">
            <label>ID do Usuário: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" v-model="idUsuario"></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="8"
            class="mt-2 mt-md-2 mt-lg-3 d-flex align-items-center justify-content-center justify-content-md-start">
            <b-button class="shadow-none btn-primary border-primary w-auto"
              @click="pos_excluir_user()">Confirmar</b-button>
          </b-col>
        </b-form-row>
      </b-form>

      <div class="container">
        <div class="row">
          <div class="col-12" v-if="excluir_user.data.length != 0">
            <div v-if="excluir_user.data.excluindoUsuarios.erro === 0">
              <b-alert variant="success" show>
                <div class="row">
                  <div class="col-2 text-center"><i class="fa-duotone fa-thumbs-up fa-3x"></i></div>
                  <div class="col-10 text-left mt-2">
                    <span class="ajusteRetCriaUser">{{
                      'ID: ' + idUsuario + ' - ' + excluir_user.data.excluindoUsuarios.xml.status.msg
                      }}</span>
                  </div>
                </div>
              </b-alert>
            </div>
            <div v-else>
              <b-alert variant="danger" show>
                <div class="row">
                  <div class="col-2 text-center"><i class="fa-duotone fa-thumbs-down fa-3x"></i></div>
                  <div class="col-10 text-left mt-2">
                    <span class="ajusteRetCriaUser">{{ 'Erro: ' + excluir_user.data.excluindoUsuarios.erro }} &nbsp;{{
                      excluir_user.data.excluindoUsuarios.msg
                    }}</span>
                  </div>
                </div>
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';
export default {
  name: 'super-pro-criar-usuario',

  data() {
    return {
      retData: '',
      infoTooltip:
        'Você precisa do ID do usuário que está cadatrado. 1) Consulte a Lista de Usuarios, ' +
        "2) anote o ID, 3) preencha o campo relacionado abaixo e por fim clique no Botão: Excluir usuário'",

      idUsuario: '',

      excluir_user: {
        data: [],
      },
    };
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    pos_excluir_user() {
      ApiService.get('https://api.sistemacpv.test/api/v1/excluir-usuarios', {
        idUsuario: this.idUsuario,
      })
        .then((response) => {
          this.excluir_user = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => { });
    },
  },
};
</script>

<style scoped>
.loading {
  height: 25vh;
}

.form-group label {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  letter-spacing: 0;
  color: #2d1a42;
  margin-bottom: 0;
}

.append {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12%;

  background-color: #f8f8f8;
  border: 1px solid #bfc9d4;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.show-password {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

input::placeholder {
  color: #c2b9ca;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.btn {
  margin-top: 4px;
  padding: 7px 16px;
}

.btn:disabled {
  border: 0px solid #00000000 !important;
}
</style>
